import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getCouponRequest = () => ({ type: 'GET_COUPON_REQUEST' })
export const getCouponSuccess = (data) => ({ type: 'GET_COUPON_SUCCESS', data })
export const getCouponFailure = (error) => ({ type: 'GET_COUPON_FAILURE', error })

export const addCouponRequest = () => ({ type: 'ADD_COUPON_REQUEST' })
export const addCouponSuccess = () => ({ type: 'ADD_COUPON_SUCCESS' })
export const addCouponFailure = (error) => ({ type: 'ADD_COUPON_FAILURE', error })

export const updateCouponRequest = () => ({ type: 'UPDATE_COUPON_REQUEST' })
export const updateCouponSuccess = () => ({ type: 'UPDATE_COUPON_SUCCESS' })
export const updateCouponFailure = (error) => ({ type: 'UPDATE_COUPON_FAILURE', error })

export const deleteCouponRequest = () => ({ type: 'DELETE_COUPON_REQUEST' })
export const deleteCouponSuccess = () => ({ type: 'DELETE_COUPON_SUCCESS' })
export const deleteCouponFailure = (error) => ({ type: 'DELETE_COUPON_FAILURE', error })

export const getCoupons = () => {
  return (dispatch) => {
    dispatch(getCouponRequest())
    fetch(URL.BASE_URL + URL.END_POINT.coupon, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getCouponSuccess(data))
      })
      .catch((error) => {
        dispatch(getCouponFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const addCoupon = (newCoupon) => {
  return (dispatch) => {
    dispatch(addCouponRequest())
    fetch(URL.BASE_URL + URL.END_POINT.coupon, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(newCoupon),
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addCouponSuccess())
        toast.success('Coupon added successfully')
        dispatch(getCoupons())
      })
      .catch((error) => {
        dispatch(addCouponFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const updateCoupon = (id, updatedCoupon) => {
  return (dispatch) => {
    dispatch(updateCouponRequest())
    fetch(URL.BASE_URL + URL.END_POINT.coupon + '?id=' + id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(updatedCoupon),
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateCouponSuccess())
        toast.success('Coupon updated successfully')
        dispatch(getCoupons())
      })
      .catch((error) => {
        dispatch(updateCouponFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const deleteCoupon = (id) => {
  return (dispatch) => {
    dispatch(deleteCouponRequest())
    fetch(URL.BASE_URL + URL.END_POINT.coupon + '?id=' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteCouponSuccess())
        toast.success('Coupon deleted successfully')
        dispatch(getCoupons())
      })
      .catch((error) => {
        dispatch(deleteCouponFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  coupons: [],
  loading: false,
  error: null,
}

export const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_COUPON_REQUEST':
    case 'ADD_COUPON_REQUEST':
    case 'UPDATE_COUPON_REQUEST':
    case 'DELETE_COUPON_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_COUPON_SUCCESS':
      return { ...state, coupons: action.data.coupons, loading: false, error: null }
    case 'ADD_COUPON_SUCCESS':
    case 'UPDATE_COUPON_SUCCESS':
    case 'DELETE_COUPON_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_COUPON_FAILURE':
    case 'ADD_COUPON_FAILURE':
    case 'UPDATE_COUPON_FAILURE':
    case 'DELETE_COUPON_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
